export default __webpack_public_path__ + "static/media/logo.c79db8cb.svg";